/**
 * @generated SignedSource<<b8cf5e465267fa5c74e6b4961343cc72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutWireTransferForm_buyer$data = {
  readonly isTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutEoriVatForm_buyer">;
  readonly " $fragmentType": "CheckoutWireTransferForm_buyer";
};
export type CheckoutWireTransferForm_buyer$key = {
  readonly " $data"?: CheckoutWireTransferForm_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutWireTransferForm_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutWireTransferForm_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutEoriVatForm_buyer"
    },
    {
      "alias": "isTrade",
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "bfcff659b8955a204dfda020e6b89d4a";

export default node;
